<template>
    <div>
        <modal :backdrop="false" size="lg" v-model="modal">
            <div slot="header">
                <button @click.prevent="closeModal" class="close" type="button">×</button>
                <div class="row">
                    <div class="col-xs-6"><h4 class="smalltitle">Add member </h4></div>
                </div>
            </div>
            <div class="block-body">
                <div class="prolabel note">User</div>
                <div class="profield">
                    <div class="row">
                        <div class="col-xs-8"><input type="text" v-model='searchText'
                                                     placeholder="Search WikiAllergies user"></div>
                        <div class="col-xs-4">
                            <button class="btn light informbtn" @click="fetchUsers()">Search</button>
                        </div>
                    </div>

                </div>

                <div class="profield fullw">
                    <ul class="itemlisttable searchuserlist samebglist">
                        <li class="itemlisthead">
                            <div style="width: 50%;">User name</div>
                            <div style="width: 10%;">DOB</div>
                            <div style="width: 13%;">User type</div>
                            <div style="width: 26%;text-align: right;">Action</div>
                        </li>
                        <li v-if="searchResult.length > 0" v-for="result in searchResult">
                            <div style="width: 50%;"><span style="font-weight: bold">{{result.fullName}}</span></div>
                            <div style="min-height: 1px;width: 10%;">
                                <span> {{result.birthday}} </span>
                            </div>
                            <div style="min-height: 1px;width: 13%;">
                                <span v-if="result.status === 'Deactived'">{{result.status}}</span>
                                <span v-if="result.status !== 'Deactived'">{{(result.role == 'allergist' || result.role ==
                                  'physician') ? 'Physician' : 'Regular User'}}</span>
                            </div>
                            <div style="width: 26%;text-align: right;">
                                <label class="inline-checkbox" v-if="result.status === 'NotAdd'">
                                    <input type="radio"
                                           @click="chooseUser(result)"
                                           :value="result.id" name="searchusercheck"> Choose
                                </label>
                                <label class="inline-checkbox"
                                       v-if="result.status !== 'NotAdd'">{{result.status}}</label>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="prolabel note">Verifying <br/>Identification
                    <a class="light" href="javascript:void(0)"
                       v-popover.right.hover="{content:'Enter the phone number or email associated with this user for identity verification. A verification code will be sent to this contact phone number or email when the user accept your invitation.'}">(?)</a>
                </div>
                <div class="profield">
                    <label class="inline-checkbox">
                        <input type="radio" name="send_code_type" v-model="dataItem.send_code_type" value="0"
                               @click="changeType(0)">
                        Email
                    </label>&nbsp;
                    <label class="inline-checkbox">
                        <input type="radio" name="send_code_type" v-model="dataItem.send_code_type" value="1"
                               @click="changeType(1)">
                        Phone
                    </label>
                    <input v-if="Number(dataItem.send_code_type) === 0" type="text" v-model="dataItem.send_code"
                           name="send_code"
                           placeholder="Enter phone number or email address">

                    <the-mask :mask="maskPhone" v-if="Number(dataItem.send_code_type) === 1"
                              :masked="maskData"
                              class="input-fax"
                              type="text" placeholder="Enter phone number or email address"
                              v-model="dataItem.send_code">
                    </the-mask>
                </div>

                <div class="prolabel note">Membership type</div>
                <div class="profield">
                    <label class="inline-checkbox">
                        <input name="type_member" type="radio" value="1" v-model="dataItem.type_member"> General member
                    </label> &nbsp;&nbsp;
                    <label class="inline-checkbox" style="padding-right: 0px !important;">
                        <input name="type_member" type="radio" value="2" v-model="dataItem.type_member">
                        Board member</label>

                    <a class="light" href="javascript:void(0)"
                       v-popover.right.hover="{content:'Board members have voting right to group\'s account and financial setting.'}">(?)</a>
                </div>

                <div class="prolabel note">Position</div>
                <div class="profield">
                    <input type="text" name="position" v-model="dataItem.position"
                           placeholder="Description of your staff's position and role">
                </div>

                <div class="prolabel note">Membership plan</div>
                <div class="profield">
                    <select v-model="dataItem.membership_plan">
                        <option value="">---Please select---</option>
                        <option v-for="membershipFee in membershipFees" :value="membershipFee.title">
                            {{membershipFee.title}}
                        </option>
                    </select>

                </div>

                <div class="prolabel note">Display this association on your profile?</div>
                <div class="profield">
                    <label class="inline-checkbox">
                        <input type="radio" v-model="dataItem.group_display_profile" value="0">
                        No
                    </label>&nbsp;
                    <label class="inline-checkbox">
                        <input type="radio" v-model="dataItem.group_display_profile" value="1">
                        Yes
                    </label>
                </div>
            </div>
            <div slot="footer">
                <button type="button" @click="addUser()" class="btn btn-default"><i class="fas fa-spinner fa-spin"
                                                                                    v-if="processingAdd"></i>Invite
                </button>
                <button @click.prevent="closeModal" class="btn btn-default" type="button">Close</button>
            </div>
        </modal>

    </div>

</template>

<script>
import httpClient from '../../../client'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'
import PreviewPdf from '../../../global/PreviewPdf'

export default {
  name: 'AddMemberModal',
  components: {},
  props: {
    group: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      modal: false,
      searchText: '',
      searchResult: [],
      searchId: 0,
      dataItem: {
        send_code_type: 0,
        send_code: '',
        type_member: 1,
        position: '',
        membership_plan: '',
        group_display_profile: 0
      },
      membershipFees: [],
      maskPhone: '(###) ###-####',
      maskData: false,
      processingAdd: false
    }
  },
  computed: {},
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
    this.getMemberShipFee()
  },
  beforeDestroy () {
  },
  methods: {
    async addUser () {
      if (this.processingAdd) {
        return
      }
      if (this.searchId == 0) { // change email
        this.alertError('Please enter name user')
        return
      }
      if (!this.dataItem.membership_plan) { //
        this.alertError('Please choose membership plan.')
        return
      }
      if (this.dataItem.send_code == '') { // change email
        this.alertError("Please enter your staff's phone number or email to verify their identity.")
        return
      }
      if (this.dataItem.send_code != '' && Number(this.dataItem.send_code_type) == 0) { // change email
        let send_code = this.dataItem.send_code
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if (re.test(String(send_code).toLowerCase()) == false) {
          this.alertError('The email entered is not correct. Please try again.')
          return
        }
      }
      if (this.dataItem.send_code != '' && this.dataItem.send_code_type == 1) { // change phone
        let send_code = this.dataItem.send_code

        if (send_code.match(/\d/g).length !== 10) {
          this.alertError('The phone number entered is not correct. Please try again.')
          return
        }
        this.dataItem.send_code.replace(/\D/g, '')
      }
      this.processingAdd = true
      try {
        let response = await httpClient.post(`/member-management/add-user`, { ...this.dataItem, id: this.searchId, groupId: this.group.id })
        this.processingAdd = false
        if (response.data.s === 200) {
          this.alertSuccess(response.data.msg)
          this.$emit('addMemberGroup')
          this.modal = false
          return
        }
        this.alertError(response.data.msg)
      } catch (e) {
        this.processingAdd = false
        console.log(e.message)
        this.alertError('Server error.Try again later')
      }
    },
    changeType (value) {
      this.dataItem.send_code = ''
    },
    chooseUser (user) {
      this.searchId = user.id
      this.searchText = user.fullName
    },
    async getMemberShipFee () {
      try {
        let response = await httpClient.get('/member-management/membership-fee-config', { params: { groupId: this.group.id } })
        if (response.data.s === 200) {
          this.membershipFees = response.data.data
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {

      }
    },
    async fetchUsers () {
      if (!this.searchText) {
        return
      }
      try {
        let response = await httpClient.get('/member-management/search', {
          params: {
            groupId: this.group.id,
            searchText: this.searchText
          }
        })
        if (response.data.s === 200) {
          let data = response.data.data
          let addeds = data.addedIds
          let users = data.users
          for (let i = 0; i < users.length; i++) {
            let info = users[i].birthday
            users[i].status = ''
            if (info) {
              // var dateFormat = new Date(info);
              let dateFormat = new Date(info)
              users[i].birthday = ('0' + (dateFormat.getMonth() + 1)).slice(-2) + '/' + ('0' + (dateFormat.getDate() + 1)).slice(-2) + '/' + dateFormat.getFullYear()
            } else {
              users[i].birthday = ''
            }
            users[i].status = 'NotAdd'
            if (addeds.length > 0) {
              for (let j = 0; j < addeds.length; j++) {
                if (users[i].id === addeds[j].memberId) {
                  if (addeds[j].status === 2) {
                    users[i].status = 'Confirm'
                  } else {
                    users[i].status = 'Added'
                  }
                  break
                }
              }
            }
          }
          this.searchResult = users
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    },
    closeModal () {
      this.modal = false
    }
  }
}
</script>
<style scoped="">

</style>
